import React, { Fragment, useEffect } from 'react';

const BackBox = (props) => {

    return (
        <Fragment>
            <div className="back3" style={props.centrar ? {textAlign: 'center'} : {}}>
                <h3>{props.title}</h3>
                <p className="tiempo">{props.subtitle ? props.subtitle : '\u00A0'}</p>
                <p className="variable">{props.value}</p>
            </div>
        </Fragment>
    );

}
export default BackBox;